import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { selectorArg1 } from '../utils/selectors';

const extractLoadingAnalyses = ({ loadingAnalyses }: RootState) =>
  loadingAnalyses;

export const areAllAnalysesLoadedSelector = (state: RootState) =>
  Object.keys(state.loadingAnalyses).length === 0;

export const isAnalysisLoadingSelector = () =>
  createSelector(
    extractLoadingAnalyses,
    selectorArg1<string>(),
    (loadingAnalyses, id) => id in loadingAnalyses,
  );

export const isAnalysisRefreshedSelector = () =>
  createSelector(
    extractLoadingAnalyses,
    selectorArg1<string>(),
    (loadingAnalyses, id) => loadingAnalyses?.[id],
  );

export const getLoadingAnalysisSelector = () =>
  createSelector(extractLoadingAnalyses, (loadingAnalyses) =>
    Object.keys(loadingAnalyses),
  );
